/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const InSubjectId: core.serialization.ObjectSchema<serializers.InSubjectId.Raw, Truvity.InSubjectId> =
    core.serialization.object({
        values: core.serialization.list(core.serialization.string()),
    });

export declare namespace InSubjectId {
    export interface Raw {
        values: string[];
    }
}
